import { create } from 'zustand';

/**
 * 数据列表 store
 *
 * 层级：store（"状态在哪"）
 *
 * 职责：
 * 1. variableList — 当前区域的动态地图数据列表
 * 2. pageData — 分页状态
 *
 * 从 editorStore 拆分出来，减少无关组件重渲染
 * （编辑器模式切换不会触发列表组件重绘）
 */
interface DataStore {
  variableList: any[];
  pageData: { current: number; pageSize: number };

  setVariableList: (list: any[]) => void;
  setPageData: (
    page:
      | { current: number; pageSize: number }
      | ((prev: { current: number; pageSize: number }) => { current: number; pageSize: number }),
  ) => void;
}

export const useDataStore = create<DataStore>((set) => ({
  variableList: [],
  pageData: { current: 1, pageSize: 10 },

  setVariableList: (list) => set({ variableList: list }),
  setPageData: (page) => set((state) => ({
    pageData: typeof page === 'function' ? page(state.pageData) : page,
  })),
}));
